<template>
  <div class="student-data__component">
    <div class="student-view__panel-content">
      <div class="panel__row">
        <student-info label="Instituição" :value="institution.name" />
        <student-info label="Curso" :value="course.name" />
        <student-info label="Nível" :value="course.level" />
        <student-info label="Tipo" :value="course.kind" />
        <student-info label="Turno" :value="course.shift" />
      </div>
      <div class="panel__row">
        <student-info label="Campus" :value="campus.name" />
        <student-info label="Quantidade de parcelas normais" :value="offer.maxPayments" />
        <student-info label="Quantidade de parcelas com o parcelamento" :value="offer.newMaxPayments" />
        <student-info label="Valor normal das parcelas" :value="offer.offeredPrice" :filter="'currency'" />
        <student-info
          label="Valor das parcelas com o parcelamento"
          :value="offer.newOfferedPrice"
          :filter="'currency'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import StudentInfo from 'components/StudentInfo';

export default {
  components: {
    StudentInfo,
  },
  props: {
    offer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    institution() {
      return this.offer.institution || {};
    },
    course() {
      return this.offer.course || {};
    },
    campus() {
      return this.course.campus || {};
    },
  },
};
</script>
